module.exports = __webpack_public_path__ + "img/ok.35f63324.png";